
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface StoryEditorArabicContentProps {
  formState: any;
  onChange: (newState: any) => void;
}

const StoryEditorArabicContent: React.FC<StoryEditorArabicContentProps> = ({ 
  formState, 
  onChange 
}) => {
  const { language } = useLanguage();
  
  return (
    <div className="space-y-4">
      <h3 className="font-medium text-sm text-muted-foreground">
        {language === "en" ? "Arabic Content" : "المحتوى العربي"}
      </h3>
      
      <div className="space-y-2">
        <label className="text-sm font-medium" htmlFor="title_ar">
          {language === "en" ? "Title (Arabic)" : "العنوان (العربية)"}
        </label>
        <Input 
          id="title_ar"
          value={formState.title_ar} 
          onChange={(e) => onChange({ ...formState, title_ar: e.target.value })}
          dir="rtl"
        />
      </div>
      
      <div className="space-y-2">
        <label className="text-sm font-medium" htmlFor="summary_ar">
          {language === "en" ? "Summary (Arabic)" : "الملخص (العربية)"}
        </label>
        <Textarea 
          id="summary_ar"
          value={formState.summary_ar} 
          onChange={(e) => onChange({ ...formState, summary_ar: e.target.value })}
          className="min-h-24"
          dir="rtl"
        />
      </div>
      
      <div className="space-y-2">
        <label className="text-sm font-medium" htmlFor="content_ar">
          {language === "en" ? "Content (Arabic)" : "المحتوى (العربية)"}
        </label>
        <Textarea 
          id="content_ar"
          value={formState.content_ar} 
          onChange={(e) => onChange({ ...formState, content_ar: e.target.value })}
          className="min-h-40"
          dir="rtl"
        />
      </div>
    </div>
  );
};

export default StoryEditorArabicContent;
